/**
 * SEO Configuration
 * Page-specific SEO metadata for all routes
 */

const SITE_URL = process.env.REACT_APP_SITE_URL || 'https://www.werkix.io';

export const seoConfig = {
  home: {
    title: 'Werkix - Empowering African Tech Talent | Global IT Solutions',
    description: 'Werkix empowers African tech talent by connecting skilled professionals with global opportunities. Specializing in software development, IT support, and tech consulting services.',
    keywords: 'African tech talent, software development, IT consulting, global tech opportunities, talent placement, remote work, technology careers',
    ogTitle: 'Werkix - Empowering African Tech Talent',
    ogDescription: 'Connecting talented individuals in Africa with abundant global market opportunities. We reshape the tech industry through seamless talent placement and career development.',
    ogImage: `${SITE_URL}/logo512.png`,
    canonical: `${SITE_URL}/`,
  },
  about: {
    title: 'About Us - Werkix | Connecting African Tech Talent Globally',
    description: 'Learn about Werkix, our mission to bridge the gap between African tech talent and global opportunities. Decades of experience in digital transformation and software development.',
    keywords: 'about Werkix, African tech talent, tech recruitment, global opportunities, software development company',
    ogTitle: 'About Werkix - Empowering African Tech Talent',
    ogDescription: 'At Werkix, we are fueled by a passion to reshape the tech industry by seamlessly connecting talented individuals in Africa with abundant global market opportunities.',
    ogImage: `${SITE_URL}/logo512.png`,
    canonical: `${SITE_URL}/about`,
  },
  careers: {
    title: 'Careers at Werkix - Join Our Mission | Tech Jobs & Opportunities',
    description: 'Join Werkix and help connect African tech talent with global opportunities. Explore open positions in software development, IT support, and technology consulting.',
    keywords: 'Werkix careers, tech jobs, software developer jobs, IT support careers, remote tech jobs, African tech opportunities',
    ogTitle: 'Careers at Werkix - Tech Jobs & Opportunities',
    ogDescription: 'Join our mission to transform the tech industry by connecting African talent with global opportunities. Explore open positions and start your career with Werkix.',
    ogImage: `${SITE_URL}/logo512.png`,
    canonical: `${SITE_URL}/careers`,
  },
  jobDetail: (job) => ({
    title: `${job.title} - Careers at Werkix | ${job.workArrangement} ${job.employmentType}`,
    description: `${job.description.substring(0, 155)}... Join Werkix and help connect African tech talent with global opportunities.`,
    keywords: `${job.title}, ${job.workArrangement}, ${job.employmentType}, tech jobs, Werkix careers, ${job.experience}`,
    ogTitle: `${job.title} - Careers at Werkix`,
    ogDescription: job.description.substring(0, 200),
    ogImage: `${SITE_URL}/logo512.png`,
    canonical: `${SITE_URL}/careers/job/${job.id}`,
  }),
  contact: {
    title: 'Contact Us - Werkix | Get in Touch',
    description: 'Contact Werkix to learn more about our services, partnerships, or career opportunities. We\'re here to help connect African tech talent with global opportunities.',
    keywords: 'contact Werkix, get in touch, Werkix contact, tech consulting contact, partnership inquiries',
    ogTitle: 'Contact Werkix - Get in Touch',
    ogDescription: 'Contact Werkix to learn more about our services, partnerships, or career opportunities. We\'re here to help connect African tech talent with global opportunities.',
    ogImage: `${SITE_URL}/logo512.png`,
    canonical: `${SITE_URL}/contact`,
  },
  ourTalents: {
    title: 'Join Our Talents - Apply Now | Werkix',
    description: 'Apply to join Werkix and connect with global tech opportunities. Submit your application and let us help you find the perfect tech career match.',
    keywords: 'apply to Werkix, join Werkix, tech talent application, career application, Werkix application',
    ogTitle: 'Join Our Talents - Apply Now | Werkix',
    ogDescription: 'Apply to join Werkix and connect with global tech opportunities. Submit your application and let us help you find the perfect tech career match.',
    ogImage: `${SITE_URL}/logo512.png`,
    canonical: `${SITE_URL}/ourtalents`,
  },
  blog: {
    title: 'What\'s New - Blog & Articles | Werkix',
    description: 'Stay updated with the latest news, insights, and updates from Werkix. Read our blog articles about tech talent, industry trends, and company updates.',
    keywords: 'Werkix blog, tech news, industry insights, company updates, tech talent news',
    ogTitle: 'What\'s New - Blog & Articles | Werkix',
    ogDescription: 'Stay updated with the latest news, insights, and updates from Werkix. Read our blog articles about tech talent, industry trends, and company updates.',
    ogImage: `${SITE_URL}/logo512.png`,
    canonical: `${SITE_URL}/blog`,
  },
  clients: {
    title: 'Our Clients - Case Studies | Werkix',
    description: 'Explore our client success stories and case studies. See how Werkix connects African tech talent with global companies and delivers exceptional results.',
    keywords: 'Werkix clients, case studies, client success stories, tech talent solutions',
    ogTitle: 'Our Clients - Case Studies | Werkix',
    ogDescription: 'Explore our client success stories and case studies. See how Werkix connects African tech talent with global companies and delivers exceptional results.',
    ogImage: `${SITE_URL}/logo512.png`,
    canonical: `${SITE_URL}/clients`,
  },
  team: {
    title: 'Our Team - Meet the Werkix Team | Werkix',
    description: 'Meet the talented team behind Werkix. Learn about our experts in tech recruitment, software development, and talent placement.',
    keywords: 'Werkix team, team members, tech recruiters, software developers, company team',
    ogTitle: 'Our Team - Meet the Werkix Team',
    ogDescription: 'Meet the talented team behind Werkix. Learn about our experts in tech recruitment, software development, and talent placement.',
    ogImage: `${SITE_URL}/logo512.png`,
    canonical: `${SITE_URL}/team`,
  },
  notFound: {
    title: '404 - Page Not Found | Werkix',
    description: 'The page you are looking for does not exist. Return to Werkix homepage to explore our services and opportunities.',
    keywords: '404, page not found, Werkix',
    ogTitle: '404 - Page Not Found | Werkix',
    ogDescription: 'The page you are looking for does not exist.',
    ogImage: `${SITE_URL}/logo512.png`,
    canonical: `${SITE_URL}/404`,
  },
};

export default seoConfig;
